var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M20.305 9.469c.347-.941.593-1.903.531-2.925a2.36 2.36 0 0 0-.756-1.616c-.491-.47-.982-.982-1.473-1.452-.634-.635-1.452-.635-2.087 0l-1.186 1.186c-.389.389-.777.757-1.145 1.145-.675.675-.675 1.473 0 2.148.47.491.961.961 1.452 1.432.123.123.143.225.082.389-.328.777-.778 1.452-1.31 2.106-1.043 1.289-2.25 2.434-3.66 3.334-.308.185-.635.328-.962.491-.164.082-.266.062-.41-.081-.47-.491-.96-.982-1.451-1.473-.635-.634-1.453-.634-2.087 0-.777.777-1.575 1.554-2.352 2.352-.655.655-.655 1.473 0 2.127.45.45.92.88 1.33 1.35.613.675 1.37.9 2.25.86 1.268-.062 2.454-.491 3.579-1.044a19.593 19.593 0 0 0 6.484-5.072c1.35-1.575 2.455-3.314 3.17-5.257z"
  }))));
};
export default SvgPhone;